import { OSHMA_TYPE } from "../data/dummy-data";

export const getCategoryLabelById = (id) => {
  const type = OSHMA_TYPE.find((item) => item.id === id);
  return type ? type.label : "—"; // ose null / undefined nqs nuk ekziston
};
